/**
 * @param {string} e
 * @returns {boolean}
 */
function notAuthError (e) {
  const errors = ['JWT_INVALID', 'JWT_EXPIRED', 'AUTHORIZATION_ERROR']
  const errorCode = e?.errorCode || e?.graphQLErrors?.[0]?.data?.errorCode || e
  const errorName = e?.errorCode || e?.graphQLErrors?.[0]?.name || e

  return !errors.includes(errorCode) && !errors.includes(errorName)
}

module.exports = { notAuthError }
